import { RootState } from '.';
import { GetCurrentUser } from 'src/store/users/reducers';

export const GetCurrentUserFromState = (state: RootState) =>
  GetCurrentUser({
    usersState: state.users || {},
    currentUserId: state.user?.id || '',
    isClient: state.user?.isClient,
  });
